import axios from "../../axios/axios";
import {objectToUrlParams} from "../../../utils/urlParams";

class HttpService {
	constructor(axiosClient = null) {
		this.axios = axiosClient || axios;
	}

	handleError(error) {
		if (error.response && error.response.status) {

			const responseData = error.response.data
			const errorMessage = responseData && (responseData.message || responseData.msg)

			switch (error.response.status) {
				case 500:
					return errorMessage || 'Something went wrong';
				case 400:
					return errorMessage || 'Bad request';
				case 401:
					return 'Unauthenticated';
				case 403:
					return 'Access Denied';
				default:
					return 'Something went wrong';
			}
		} else {
			return 'Network error';
		}
	}

	objectToQueryPrams(object) {
		return objectToUrlParams(object)
	}

	paesehandleError(error) {
		if (error.response.data.message) {
			return error.response.data.message;
		}
		return this.handleError(error);
	}
}

export default HttpService